const Spinner = () => {
	return (
		<div
			aria-busy="true"
			className="loader loader-fixed"
			id="spinner"
			role="alert"
		></div>
	);
};

export { Spinner };
